import axios from "axios";

export const validateToken = async () => {
 
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  if (!token) return false;

  console.log('==================')
  console.log(userId)
  // return true

  try {
    const response = await axios.post(
      // `${process.env.REACT_APP_BACKEND_URL}/api/validate-token/${userId}`,
      `${process.env.REACT_APP_BACKEND_URL}/api/verifyToken/isValid/${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log('===================================')
    console.log(response)

    return response.status === 200;
  } catch (error) {
    console.error("Token validation failed:", error);
    return false;
  }
};

